import { CHART_FILTERS_TYPE } from '../../constants';

const { DAY, MONTH, QUARTER, WEEK, YEAR } = CHART_FILTERS_TYPE;

export const FILTERS = [
  {
    title: DAY.title,
    type: DAY.type,
  },
  {
    title: WEEK.title,
    type: WEEK.type,
  },
  {
    title: MONTH.title,
    type: MONTH.type,
  },
  {
    title: QUARTER.title,
    type: QUARTER.type,
  },
  {
    title: YEAR.title,
    type: YEAR.type,
  },
];



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/Filters/filters.js